import { css } from "@emotion/react"

export function HorizontalRule() {
  return (
    <hr
      className="m-0 bw-0"
      css={css`
        border-bottom: 1px solid var(--color-tint5);
      `}
    />
  )
}
